import React, { useState, useEffect } from 'react'

import { Trash } from 'lucide-react'
import { Row, Col, ButtonIcon } from 'twyne-new.ui'

import Input from 'components/form/Input'

import MergetagInputTip from './MergetagInputTip'
import { STATIC_OPTION } from './ParamItem'
import SelectCreatable from './SelectCreatable'

export default function HeaderItem({ data: [header, value, ignore], onDelete, onChange, index }) {
  return <Row>
    <Col size='6'>
      <HeaderComponent
        name={'_'}
        clearable={false}
        placeholder="create a custom header"
        value={header}
        promptTextCreator={label => `Create the new custom header "${label}"`}
        onChange={header => onChange && onChange(header, value)}
      />
    </Col>
    <Col size='5'>
      <MergetagInputTip id={`hvalue-${index}`}>
        <Input
          name={!ignore ? `request_config[headers][${header}]` : '_'}
          placeholder="value"
          value={value}
          onChange={e => onChange && onChange(header, e.target.value)}
        />
      </MergetagInputTip>
    </Col>
    {!onDelete ? null : <Col size='1' className='flex items-center'>
      <ButtonIcon content='Delete' onClick={() => onDelete()}>
        <Trash size={16} />
      </ButtonIcon>
    </Col>}
  </Row>
}

function HeaderComponent({ value, name, onChange, index, ...selectProps }) {
  const [staticValue, setStaticValue] = useState(false)

  const loadValue = value => {
    if (value === '')
      return setStaticValue(false)
  }

  useEffect(() => { loadValue(value) }, [value])

  if (staticValue)
    return <MergetagInputTip id={`hkey-${index}`}>
      <Inputy {...{ value, name }}
        onChange={e => onChange && onChange(e.target.value)}
        placeholder='type a static value or create a mergetag'
      />
    </MergetagInputTip>

  return <SelectCreatable {...{ value, name, ...selectProps }}
    handleOnChange={option => {
      if (option === STATIC_OPTION)
        return setStaticValue(true)
      onChange && option && onChange(option.value)
    }}
  />
}